var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 request_list",attrs:{"headers":_vm.requestHeaders,"items":_vm.requestList,"items-per-page":15,"loading":_vm.isLoading},on:{"click:row":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }